export default __webpack_public_path__ + "static/media/faq_question_bullet.5637326c.svg";